<template>
  <div id="app" :class="{ bankabc: env.isBankabc, 'vivo-browser': env.isVivoBrowser }" @click="noop">
    <ABCHeader v-if="env.isBankabc" />
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <portal-target name="image-preview" data-html2canvas-ignore="true"></portal-target>
    <portal-target name="fix-menu" multiple class="side-menu" data-html2canvas-ignore="true"></portal-target>
    <portal to="fix-menu" :order="1" data-html2canvas-ignore="true">
      <fix-menu></fix-menu>
    </portal>
  </div>
</template>

<script>
import shop from 'utils/shop'
import env from 'utils/clientEnv'
import { getParameter, getCookie } from 'utils/common'
import ABCHeader from 'components/abc-header'
import FixMenu from 'components/fix-menu'

export default {
  components: {
    ABCHeader,
    FixMenu
  },
  data() {
    return {
      env
    }
  },
  created() {
    // 设置小程序authCode
    env.isWeChatApp().then(res => {
      // 小程序
      if (res) {
        sessionStorage.setItem('authCode', getParameter('authCode'))
      }
    })
    this.getParam()
    // 将refrerer存入cookie
    shop.setReferrer()
  },
  methods: {
    getParam() {
      const bankchannel = getParameter('bankchannel') || getCookie('bankchannel')
      if (bankchannel) {
        sessionStorage.setItem('bankchannel', bankchannel)
      }
    },
    noop() {}
  }
}
</script>
